/**
 * Turning a blog post's stored content into HTML. Shared by the list (/blog)
 * and each post's page (/blog/<slug>). Both server and browser use it. The
 * output still goes through sanitizeHtml at the point of rendering.
 */
import { marked } from "marked";

/**
 * Quill HTML is used as it is, minus layout classes that older saves carried.
 * Anything else is legacy markdown.
 */
export function renderPostContent(content: string): string {
  if (!content) return "";
  const trimmed = content.trim();
  const html =
    trimmed.startsWith("<") && trimmed.endsWith(">")
      ? content
          .replace(/flex flex-col h-full min-h-\[280px\]/g, "")
          .replace(
            /overflow-y-auto pr-2 max-h-\[320px\] custom-scrollbar flex-grow/g,
            "",
          )
      : (marked.parse(content) as string);
  // .ql-editor keeps white-space (pre-wrap), so the newlines markdown puts
  // between tags would show as blank lines. Quill's own HTML has none.
  return html.replace(/>\n+</g, "><").trim();
}

/** A title without leading markdown heading marks, which some saves carry. */
export function cleanPostTitle(title: string): string {
  if (!title) return "";
  return title.replace(/(^|<[^>]+>)\s*#{1,6}\s+/g, "$1").trim();
}
